import { HeartSmall } from '@wix/wix-ui-icons-common/on-stage/reactions';
export default HeartSmall;
//# sourceMappingURL=heart-icon.js.map